import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './NotFoundPage.css';

function NotFoundPage() {
  useEffect(() => {
    // Set HTTP status to 404 for SSR/static generation
    if (typeof window !== 'undefined' && window.history) {
      // This helps with client-side routing
      document.title = '404 - Page Not Found | iGames.ng';
    }
  }, []);

  return (
    <div className="App">
      <SEO 
        title="404 - Page Not Found | iGames.ng"
        description="The page you're looking for doesn't exist. Browse our collection of 3000+ free casino games at iGames.ng"
        noindex={true}
      />
      <Header />
      <main className="not-found-page">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Page Not Found</h2>
          <p className="not-found-text">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="not-found-actions">
            <Link to="/" className="not-found-button">
              🎮 Back to Games
            </Link>
            <Link to="/tips" className="not-found-button">
              💡 Tips
            </Link>
            <Link to="/faqs" className="not-found-button">
              ❓ FAQs
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
